interface RedirectIconProps {
  className?: string
}

export const RedirectIcon = ({ className }: RedirectIconProps) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.6289 11.4282C15.6289 13.1372 15.6289 13.9917 15.2614 14.6282C15.0207 15.0452 14.6744 15.3915 14.2575 15.6322C13.621 15.9997 12.7665 15.9997 11.0575 15.9997H6.48605C3.90008 15.9997 2.6071 15.9997 1.80372 15.1963C1.00033 14.3929 1.00033 13.0999 1.00033 10.514V5.94252C1.00033 4.23351 1.00033 3.379 1.36779 2.74252C1.60852 2.32555 1.95476 1.9793 2.37176 1.73856C3.00829 1.37109 3.86278 1.37109 5.57176 1.37109"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M16.9492 1C16.9492 0.585786 16.6134 0.25 16.1992 0.25L9.44922 0.25C9.03501 0.25 8.69922 0.585786 8.69922 1C8.69922 1.41421 9.03501 1.75 9.44922 1.75H15.4492V7.75C15.4492 8.16421 15.785 8.5 16.1992 8.5C16.6134 8.5 16.9492 8.16421 16.9492 7.75L16.9492 1ZM7.19922 10L7.72955 10.5303L16.7295 1.53033L16.1992 1L15.6689 0.46967L6.66889 9.46967L7.19922 10Z"
        fill="white"
      />
    </svg>
  )
}
